import { ApiService } from '../apiService'

/** Mirrors GiftRewardContentType (AdventureCore.Domain.Enums.GiftRewardEnums). */
export const contentTypeLabel: Record<number, string> = {
  0: 'Image',
  1: 'Link',
  2: 'Text',
  3: 'QR redeemable',
  4: 'Adventure unlock',
}

/** Mirrors DistributionType. */
export const distributionTypeLabel: Record<number, string> = {
  0: 'Manual',
  1: 'Time interval',
  2: 'Specific date',
  3: 'Every Nth',
  4: 'Percentage',
}

/** Mirrors AdventureCore.Application.DTOs.Admin.AdminRewardSummaryDto. */
export interface AdminRewardSummaryDto {
  id: string
  title: string
  description?: string | null
  groupId: string
  groupName: string
  isActive: boolean
  contentType: number
  distributionType: number
  totalLimit?: number | null
  usesPerInstance?: number | null
  expirationType: number
  fixedExpirationDate?: string | null
  createdAt: string
  activeInstanceCount: number
  totalInstanceCount: number
}

export interface AdminRewardListResponse {
  items: AdminRewardSummaryDto[]
  totalCount: number
  page: number
  pageSize: number
}

export interface AdminRewardListParams {
  query?: string
  activeOnly?: boolean
  page?: number
  pageSize?: number
}

export const adminRewardsApi = {
  list: (params: AdminRewardListParams) =>
    ApiService.get<AdminRewardListResponse>('/admin/rewards', params),
}
